import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
import useClientPlants from "../../../hooks/useClientPlants";

const PlantContext = createContext(null);

export function PlantProvider({ children }) {
  const { plantId } = useParams();
  const { plants, loading: plantsLoading } = useClientPlants();
  const plant = plants?.find((p) => String(p.id) === String(plantId)) || { id: plantId };

  return (
    <PlantContext.Provider value={{ plantId, plant, plants, plantsLoading }}>
      {children}
    </PlantContext.Provider>
  );
}

export function usePlantContext() {
  const ctx = useContext(PlantContext);
  if (!ctx)
    throw new Error("usePlantContext must be used inside PlantProvider");
  return ctx;
}
